/* Galerie des fiches produit et vidéo « Le siwak en 50 secondes » (v26, 12/10/2026, demande de Xebec).
   Avant : une seule grande image dont on changeait la source au clic. Chaque image se chargeait
   seulement à ce moment-là (attente) et on ne pouvait pas faire glisser au doigt.
   Maintenant :
   1. Toutes les images sur une bande qui glisse au doigt (défilement natif aimanté), à la souris
      sur ordinateur (glisser), au pavé tactile, au clavier (flèches), avec les flèches et les vignettes.
   2. Les images voisines sont chargées tout de suite après la page, les autres juste après
      (ou dès que l'on touche la galerie). Économie de données : seulement les voisines.
   3. Diapositive vidéo (vignette avec data-video) : lecture muette quand elle est à l'écran,
      pause sinon, bouton son, toucher pour pause. Aussi utilisé hors galerie ([data-kxv-inline]).
   Le reste de la fiche (formules, bouton d'achat) n'est pas touché. */
(function () {
  'use strict';
  var mq = function (q) { return window.matchMedia && matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  var SVG_SON_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9l5 6M21 9l-5 6"/></svg>';
  var SVG_SON_ON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>';
  var SVG_DEBUT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4.5h4.5"/></svg>';
  var SVG_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';

  /* ---------- Lecteur vidéo commun ---------- */
  function KxVid(box) {
    var v = box.querySelector('video');
    var son = box.querySelector('.kxv-son');
    var play = box.querySelector('.kxv-play');
    var self = { box: box, v: v, wanted: false, userPaused: false };
    /* v27 (demande de Xebec) : bouton « Revoir depuis le début ». */
    if (!box.querySelector('.kxv-debut')) box.insertAdjacentHTML('beforeend', '<button class="kxv-debut" type="button" aria-label="Revoir la vidéo depuis le début">' + SVG_DEBUT + '</button>');
    var debut = box.querySelector('.kxv-debut');
    function etat() {
      box.classList.toggle('is-paused', v.paused);
      if (son) {
        son.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        son.innerHTML = (v.muted ? SVG_SON_OFF : SVG_SON_ON) + '<span>' + (v.muted ? 'Activer le son' : 'Couper le son') + '</span>';
      }
    }
    function lancer() {
      if (v.preload === 'none') v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () { etat(); });
    }
    self.activer = function (on) {
      self.wanted = on;
      if (on && !self.userPaused && !(reduce || saveData)) lancer();
      else if (!on && !v.paused) v.pause();
      etat();
    };
    self.precharger = function () { if (v.preload === 'none') v.preload = 'metadata'; };
    /* Le libellé « Activer le son » reste 4 s, puis le bouton se réduit à l'icône (moins de texte de la vidéo caché). */
    var compactT = 0;
    v.addEventListener('play', function () {
      if (!compactT) compactT = setTimeout(function () { box.classList.add('is-compact'); }, 4000);
      etat();
    });
    v.addEventListener('pause', etat);
    v.addEventListener('volumechange', etat);
    v.addEventListener('click', function () {
      if (box.__kxDrag) return;
      if (v.paused) { self.userPaused = false; lancer(); } else { self.userPaused = true; v.pause(); }
    });
    if (play) play.addEventListener('click', function () { self.userPaused = false; lancer(); });
    debut.addEventListener('click', function () {
      try { v.currentTime = 0; } catch (e) {}
      self.userPaused = false; lancer();
    });
    if (son) son.addEventListener('click', function () {
      v.muted = !v.muted;
      if (!v.muted && v.paused) { self.userPaused = false; lancer(); }
      etat();
    });
    etat();
    return self;
  }
  function htmlLecteur(src, poster, label) {
    var e = function (s) { return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
    return '<div class="kxv-box is-paused">' +
      '<video class="kxv-video" playsinline muted loop preload="none" poster="' + e(poster) + '" aria-label="' + e(label) + '">' +
      '<source src="' + e(src) + '" type="video/mp4"></video>' +
      '<button class="kxv-play" type="button" aria-label="Lire la vidéo">' + SVG_PLAY + '</button>' +
      '<button class="kxv-son" type="button" aria-pressed="false"></button></div>';
  }

  /* ---------- Vidéos hors galerie (accueil) ---------- */
  [].forEach.call(document.querySelectorAll('[data-kxv-inline]'), function (el) {
    if (el.__kxv) return; el.__kxv = true;
    el.innerHTML = htmlLecteur(el.getAttribute('data-src'), el.getAttribute('data-poster'), el.getAttribute('data-label'));
    var lec = KxVid(el.querySelector('.kxv-box'));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          if (x.isIntersecting) lec.precharger();
          lec.activer(x.intersectionRatio >= 0.55);
        });
      }, { threshold: [0, 0.55], rootMargin: '200px 0px' }).observe(el);
    }
  });

  /* ---------- Galerie des fiches produit ---------- */
  var stage = document.querySelector('.pdp__stage');
  if (!stage || stage.__kxg) return;
  var hero = stage.querySelector('.pdp__hero');
  var thumbsBox = document.querySelector('.pdp__thumbs');
  var thumbs = [].slice.call(document.querySelectorAll('.pdp__thumb'));
  if (!hero || thumbs.length < 2 || !('scrollTo' in Element.prototype)) return;
  stage.__kxg = true;

  var n = thumbs.length, cur = 0, cible = -1, cibleT = 0;
  var stageVisible = true;
  var lecteurs = {};
  /* La bande est écrite dans le HTML de la fiche (l'image principale n'est jamais déplacée, sinon son
     affichage était retardé). Si elle manque (ancien gabarit), on la construit ici. */
  var track = stage.querySelector('.kxg__track');
  if (!track) {
    track = document.createElement('div');
    track.className = 'kxg__track';
    thumbs.forEach(function (th, i) {
      var s = document.createElement('div');
      s.className = 'kxg__slide';
      s.setAttribute('role', 'group');
      s.setAttribute('aria-roledescription', 'diapositive');
      s.setAttribute('aria-label', (i + 1) + ' sur ' + n);
      if (i === 0) {
        s.appendChild(hero);
      } else if (th.getAttribute('data-video')) {
        s.classList.add('kxg__slide--video');
        s.innerHTML = htmlLecteur(th.getAttribute('data-video'), th.getAttribute('data-poster'), th.alt);
      } else {
        var im = document.createElement('img');
        im.className = 'kxg__img';
        im.alt = th.alt || '';
        im.width = 1200; im.height = 1200;
        im.decoding = 'async';
        im.draggable = false;
        im.setAttribute('sizes', hero.getAttribute('sizes') || '100vw');
        im.setAttribute('data-src', th.getAttribute('data-full') || th.src);
        if (th.getAttribute('data-srcset')) im.setAttribute('data-srcset', th.getAttribute('data-srcset'));
        s.appendChild(im);
      }
      track.appendChild(s);
    });
    stage.insertBefore(track, stage.firstChild);
    stage.classList.add('kxg-on');
  }
  var slides = [].slice.call(track.children);
  if (slides.length !== n) return;
  slides.forEach(function (s, i) { var b = s.querySelector('.kxv-box'); if (b) lecteurs[i] = KxVid(b); });
  hero.draggable = false;

  /* Chargement */
  function charger(i) {
    var s = slides[i];
    if (!s || s.__ok) return;
    s.__ok = true;
    var im = s.querySelector('img[data-src]');
    if (im) {
      if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
    }
    var v = s.querySelector('video[data-poster]');
    if (v) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); }
    if (lecteurs[i]) lecteurs[i].precharger();
  }
  function chargerAutour(i) { charger(i); charger((i + 1) % n); charger((i - 1 + n) % n); }
  var toutDemande = false;
  function chargerTout() {
    if (toutDemande) return;
    toutDemande = true;
    for (var k = 1; k < n; k++) {
      var im = slides[k].querySelector('img[data-src]');
      if (im) im.setAttribute('fetchpriority', 'low');
      charger(k);
    }
  }
  function apresPage() {
    chargerAutour(0);
    if (!saveData) setTimeout(chargerTout, 1200);
  }
  /* La voisine de droite tout de suite (priorité basse, après l'image principale), le reste après la page. */
  (function () { var im = slides[1] && slides[1].querySelector('img[data-src]'); if (im) im.setAttribute('fetchpriority', 'low'); charger(1); })();
  if (document.readyState === 'complete') apresPage(); else window.addEventListener('load', apresPage);

  /* Position */
  function largeur() { return track.clientWidth || 1; }
  function marquer(i) {
    cur = i;
    thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    if (thumbsBox && thumbsBox.scrollWidth > thumbsBox.clientWidth + 2) {
      var t = thumbs[i].getBoundingClientRect(), b = thumbsBox.getBoundingClientRect();
      var g = thumbsBox.scrollLeft + (t.left - b.left) - (b.width - t.width) / 2;
      thumbsBox.scrollTo({ left: Math.max(0, g), behavior: reduce ? 'auto' : 'smooth' });
    }
    Object.keys(lecteurs).forEach(function (k) { lecteurs[k].activer(+k === i && stageVisible); });
  }
  function aller(i, doux) {
    i = (i + n) % n;
    chargerAutour(i);
    cible = i; clearTimeout(cibleT);
    cibleT = setTimeout(function () { cible = -1; }, 900);
    track.scrollTo({ left: i * largeur(), behavior: (doux === false || reduce) ? 'auto' : 'smooth' });
    marquer(i);
  }
  var raf = 0;
  function suivrePosition(fin) {
    var x = track.scrollLeft, i = Math.round(x / largeur());
    if (cible >= 0) {
      if (fin || Math.abs(x - cible * largeur()) < 3) { cible = -1; clearTimeout(cibleT); }
      else return;
    }
    if (i !== cur && i >= 0 && i < n) { marquer(i); chargerAutour(i); }
  }
  track.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; suivrePosition(false); });
  }, { passive: true });
  track.addEventListener('scrollend', function () { suivrePosition(true); });

  /* Flèches, vignettes, clavier */
  var prec = stage.querySelector('.pdp__nav--prev'), suiv = stage.querySelector('.pdp__nav--next');
  if (prec) prec.addEventListener('click', function () { chargerTout(); aller(cur - 1); });
  if (suiv) suiv.addEventListener('click', function () { chargerTout(); aller(cur + 1); });
  thumbs.forEach(function (th, j) {
    th.setAttribute('aria-label', (th.getAttribute('data-video') ? 'Afficher la vidéo ' : 'Afficher l’image ') + (j + 1) + ' sur ' + n);
    th.addEventListener('click', function () { chargerTout(); aller(j); });
    th.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); chargerTout(); aller(j); }
    });
  });
  stage.addEventListener('keydown', function (e) {
    if (e.target.closest && e.target.closest('button') && e.target.closest('.kxv-box')) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); aller(cur + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); aller(cur - 1); }
  });
  ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
    stage.addEventListener(ev, function () { chargerTout(); }, { passive: true, once: true });
  });

  /* Glisser à la souris (ordinateur) */
  var drag = null;
  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    if (e.target.closest && e.target.closest('button')) return;
    drag = { x: e.clientX, gauche: track.scrollLeft, bouge: false, id: e.pointerId };
  });
  window.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.bouge && Math.abs(dx) > 6) {
      drag.bouge = true; cible = -1;
      track.classList.add('is-drag');
      try { track.setPointerCapture(drag.id); } catch (_) {}
    }
    if (drag.bouge) { track.scrollLeft = drag.gauche - dx; e.preventDefault(); }
  });
  function finDrag(e) {
    if (!drag) return;
    var d = drag; drag = null;
    if (!d.bouge) return;
    var dx = (e.clientX || d.x) - d.x;
    var depart = Math.round(d.gauche / largeur());
    var i = depart + (dx < -50 ? 1 : dx > 50 ? -1 : 0);
    i = Math.max(0, Math.min(n - 1, i));
    track.classList.remove('is-drag');
    slides.forEach(function (s) { s.querySelector('.kxv-box') && (s.querySelector('.kxv-box').__kxDrag = true); });
    setTimeout(function () { slides.forEach(function (s) { var b = s.querySelector('.kxv-box'); if (b) b.__kxDrag = false; }); }, 60);
    aller(i);
  }
  window.addEventListener('pointerup', finDrag);
  window.addEventListener('pointercancel', finDrag);

  /* Taille d'écran qui change : on garde la même image */
  var lw = largeur();
  window.addEventListener('resize', function () {
    var w = largeur();
    if (w !== lw) { lw = w; track.scrollTo({ left: cur * w, behavior: 'auto' }); }
  });

  /* Vidéo : pause quand la galerie sort de l'écran */
  if ('IntersectionObserver' in window && Object.keys(lecteurs).length) {
    new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        stageVisible = x.intersectionRatio >= 0.5;
        Object.keys(lecteurs).forEach(function (k) { lecteurs[k].activer(+k === cur && stageVisible); });
      });
    }, { threshold: [0, 0.5] }).observe(stage);
  }
})();
